import { isProposalSigned } from '../../../db/entities/proposal/ProposalEntity';
import type ProposalEntity from '../../../db/entities/proposal/ProposalEntity';

interface ResolvePdfDeps {
  getSignedLink: (uuid: string) => Promise<string>;
  generate: (proposal: ProposalEntity) => Promise<string | undefined>;
}

// A signed quote has its signed PDF stored on the server; regenerating would drop the
// signature. If the stored file is missing (404), fall back to the generated PDF.
export async function resolveProposalPdfUrl(
  proposal: ProposalEntity,
  { getSignedLink, generate }: ResolvePdfDeps
): Promise<string | undefined> {
  if (isProposalSigned(proposal)) {
    try {
      return await getSignedLink(proposal.uuid);
    } catch (error) {
      if ((error as { response?: { status?: number } })?.response?.status !== 404) {
        throw error;
      }
    }
  }

  return generate(proposal);
}
